import React from 'react';
import AclAutoPreview from './acl-auto/AclAutoPreview.js';

export default function App() {
  return <AclAutoPreview />;
}
